(function ($) {
	toggle_header_style();

	// sticky header
	window.onscroll = function () {
		toggle_header_style();
	};

	function toggle_header_style() {
		if (
			document.body.scrollTop > 50 ||
			document.documentElement.scrollTop > 50
		) {
			$("#wrapper-navbar").addClass("scrolled");
		} else {
			$("#wrapper-navbar").removeClass("scrolled");
		}
	}

	function openSearch() {
		$(".btn-search").addClass("active");
		$(".searchform").addClass("active");
		setTimeout(() => {
			$('.searchform input[type="text"]').trigger("focus");
		}, 300);
	}

	function closeSearch() {
		$(".btn-search").removeClass("active");
		$(".searchform").removeClass("active");
	}

	// On Dom Ready
	$(function () {
		$(".menu-open").on("click", function (e) {
			e.preventDefault();
			$(this).toggleClass("active");
			$(".mobile-menu-wrapper").toggleClass("active");
			$("body").toggleClass("menu-opened");
			$(".mobile-menu-wrapper").slideToggle();
		});

		$(".btn-search").on("click", function (e) {
			e.preventDefault();
			if ($(this).hasClass("active")) {
				closeSearch();
			} else {
				openSearch();
			}
		});

		// Toggle main menu sub menu on focus
		$("header#wrapper-navbar ul.primary-menu a").on("focus", function (e) {
			e.preventDefault();
			$(
				"header#wrapper-navbar ul.primary-menu > li.menu-item-has-children"
			).removeClass("active");
			$(
				"header#wrapper-navbar ul.primary-menu > li.menu-item-has-children > a"
			).removeAttr("aria-expanded");
			if (
				$(this).parent().hasClass("menu-item-has-children") ||
				$(this).parent().parent().hasClass("sub-menu")
			) {
				$(this).closest(".menu-item-has-children").addClass("active");
				$(this)
					.closest(".menu-item-has-children > a")
					.attr("aria-expanded", "true");
			}
			// else {
			//   $("header#wrapper-navbar ul.primary-menu > li.menu-item-has-children").removeClass("active");
			//   $("header#wrapper-navbar ul.primary-menu > li.menu-item-has-children > a").removeAttr("aria-expanded");
			// }
		});
		$("header#wrapper-navbar .primary-menu__right>li .btn-search").on(
			"focus",
			function (e) {
				e.preventDefault();
				$(
					"header#wrapper-navbar ul.primary-menu > li.menu-item-has-children"
				).removeClass("active");
				$(
					"header#wrapper-navbar ul.primary-menu > li.menu-item-has-children > a"
				).removeAttr("aria-expanded");
			}
		);
		$("header#wrapper-navbar ul.primary-menu a").on("click", function (e) {
			$(
				"header#wrapper-navbar ul.primary-menu > li.menu-item-has-children"
			).removeClass("active");
			$(
				"header#wrapper-navbar ul.primary-menu > li.menu-item-has-children > a"
			).removeAttr("aria-expanded");
		});

		// Hide search form when clicked outside
		$(document).on("click", function (e) {
			var $target = $(e.target);

			if (
				!$target.closest(".searchform").length &&
				!$target.hasClass("btn-search") &&
				!$target.hasClass("fa-search")
			) {
				closeSearch();
			}
		});

		// Toggle mobile submenu
		$(
			".mobile-menu-wrapper .menus-wrapper ul.mobile-menu>li.menu-item-has-children .toggle-submenu"
		).on("click", function (e) {
			e.preventDefault();
			$(this).toggleClass("active");
			$(this).parent().find(".sub-menu").slideToggle();
		});
	});
})(jQuery);
